module.exports = __webpack_public_path__ + "img/loves_pet.764e4ffc.png";